/** @file gizmoUnit: a GIZMO_METRICS length in CSS pixels as a fraction of the gizmo radius (unit frame). */
import { GIZMO_METRICS } from './gizmoMetrics';

/** `px / GIZMO_METRICS.radius`. */
export function gizmoUnit(px: number): number {
  return px / GIZMO_METRICS.radius;
}
